<template>
  <v-dialog
    transition="dialog-top-transition"
    max-width="600"
  >
    <template v-slot:activator="{ on, attrs }">
      <slot v-bind="{ dialogOn: on, on, attrs }" />
    </template>
    <template v-slot:default="dialog">
      <v-card class="mx-auto">
        <v-card-title class="text-heading-4 font-weight-bold">
          {{ $t('confirmationModal.message') }}
        </v-card-title>
        <v-card-actions class="justify-end">
          <v-btn
            color="primary"
            class="me-3 mt-4"
            @click="onConfirm(dialog)"
          >
            {{ $t('button.yes') }}
          </v-btn>
          <v-btn
            color="secondary"
            outlined
            class="mt-4"
            @click="onCancel(dialog)"
          >
            {{ $t('button.no') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
export default {
  methods: {
    onConfirm(dialog) {
      this.hideDialog(dialog);
      this.$emit('on-confirming');
    },

    onCancel(dialog) {
      this.hideDialog(dialog);
      this.$emit('on-cancellation');
    },

    hideDialog(dialog) {
      Object.assign(dialog, { value: false });
    },
  },
};
</script>
